import React from "react";
import PropTypes from "prop-types";

const StoreItemSummaryCategoryPrice = ({
    formattedQuantityTotalPrice,
    formattedSingleItemPrice,
    hasMultipleStoreItems,
    isVisible,
}) =>
    isVisible ? (
        <small>
            {hasMultipleStoreItems ? (
                <>
                    {formattedQuantityTotalPrice}
                    <br />
                    {`(${formattedSingleItemPrice} each)`}
                </>
            ) : (
                formattedSingleItemPrice
            )}
        </small>
    ) : null;

StoreItemSummaryCategoryPrice.propTypes = {
    // Currency formatted price number as a string
    formattedSingleItemPrice: PropTypes.string.isRequired,
    // Currency formatted promo code discounted price number as a string
    formattedQuantityTotalPrice: PropTypes.string.isRequired,
    // Flag telling us to display multiple items ui
    hasMultipleStoreItems: PropTypes.bool.isRequired,
    // Flag telling us that the price should be visible
    isVisible: PropTypes.bool.isRequired,
};

export default StoreItemSummaryCategoryPrice;
